import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
              热门榜单
            </h2>
            <p className="text-sm text-foreground-500">实时热度排行 · 每日更新</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">热度榜</span>
            <span className="px-3 py-1.5 rounded-full bg-background-200 text-foreground-500 text-xs font-medium whitespace-nowrap">新上线</span>
            <span className="px-3 py-1.5 rounded-full bg-background-200 text-foreground-500 text-xs font-medium whitespace-nowrap">口碑</span>
          </div>
        </div>

        <div className="space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors duration-200"
            >
              <div className={`w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-300 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 whitespace-nowrap">{item.category}</p>
              </div>

              {item.tag && (
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              )}

              <div className="flex items-center gap-1 flex-shrink-0">
                <span className="text-sm font-heading font-bold text-primary-600">{item.heat}</span>
                <i className={`text-xs ${item.trend === 'up' ? 'ri-arrow-up-s-fill text-green-500' : 'ri-subtract-line text-foreground-400'}`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}